import { render, staticRenderFns } from "./NoticiasView.vue?vue&type=template&id=10e9f30e&scoped=true&"
import script from "./NoticiasView.vue?vue&type=script&lang=js&"
export * from "./NoticiasView.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasView.vue?vue&type=style&index=0&id=10e9f30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9f30e",
  null
  
)

export default component.exports